// Feature switches. Flip a flag back to true to restore the feature —
// all of its code stays in the codebase.
//
// DIRECTORY_ENABLED: public driver directory (/drivers, driver public
// profiles, "Search for a Driver" entry points, driver Public Profile tab
// and the admin Directory Approvals section).
export const DIRECTORY_ENABLED = false;
